import { defaultLocale, normalizeLocale } from '@/lib/i18n/config';

function getClientApiOrigin() {
  return (process.env.NEXT_PUBLIC_API_ORIGIN || '').replace(/\/+$/, '');
}

function buildClientUrl(pathname) {
  if (/^https?:\/\//.test(pathname)) {
    return pathname;
  }

  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const apiOrigin = getClientApiOrigin();
  return `${apiOrigin}${normalizedPath}`;
}

export async function clientFetch(pathname, init = {}) {
  const headers = new Headers(init.headers || {});
  const storedLocale =
    typeof window !== 'undefined'
      ? window.localStorage.getItem('i18nextLng') ||
        window.navigator.language ||
        document.documentElement.lang
      : defaultLocale;

  if (!headers.has('accept')) {
    headers.set('accept', 'application/json');
  }

  if (!headers.has('x-lang')) {
    headers.set('x-lang', normalizeLocale(storedLocale || defaultLocale));
  }

  const response = await fetch(buildClientUrl(pathname), {
    ...init,
    headers,
    credentials: 'include',
  });

  const contentType = response.headers.get('content-type') || '';

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`);
    error.status = response.status;

    if (contentType.includes('application/json')) {
      error.data = await response.json();
    } else {
      error.data = await response.text();
    }

    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  if (contentType.includes('application/json')) {
    return response.json();
  }

  return response.text();
}
